// Common functionnalities for map components
// @see ApthMap.vue
// @see ApthMapStop.vue

// Import utilities
import { polyline } from "leaflet";
import { PolylineUtil } from "../../lib/utils.ts";
import { Icon } from "leaflet";

// Leaflet fullscreen plugin and controls
import L from 'leaflet';
import 'leaflet.fullscreen';

export default {
  data() {
    return {
      zoom: 15,
      currentZoom: 15,
      center: this.initialPos(),
      bounds: null,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
    };
  },
  props: {
    url: {
      type: String,
      required: false,
      default: () => {
        return "//server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
      },
    },
    attribution: {
      type: String,
      required: false,
      default: () => { return ""; },
    },
    network: {
      type: String,
      required: true,
    },
    zoomMin: {
      type: Number,
      required: false,
      default: () => {
        return 14;
      },
    },
    line: {
      type: String,
      required: false,
      default: () => null,
    },
    stops: {
      type: Array,
      required: true,
      default: () => {
        return {};
      },
    },
    lines: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    shapes: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    // Fix 404 errors on marker icons
    // By default, Leaflet use marker icons and we get 404 errors on them when using the compiled widget
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  },
  computed: {
    stopMarkerProperties() {
      return {
        iconSize: [22, 31],
        iconAnchor: [10, 32],
        popupAnchor: [0, -37],
      }
    },
    polylines() {
      let lineColor = "FFF";
      if (this.line && this.lines[this.line]) {
        lineColor = this.lines[this.line].colors.bgcolor;
      }
      let options = {
        color: lineColor,
        weight: 4,
        opacity: 0.9,
        lineJoin: "round",
      };
      let shapes = this.shapes.map((shape) => {
        return polyline(PolylineUtil.decode(shape), options);
      });
      return shapes;
    },
  },
  methods: {
    translate(key, fallback) {
      return this.$te(key) ? this.$t(key) : fallback
    },
    onMapReady(map) {
      this.bounds = map.getBounds();
      map.addControl(new L.control.fullscreen({
        position: 'bottomright',
        title: this.translate('fullscreenTitle', 'Full screen'),
        titleCancel: this.translate('fullscreenTitleCancel', 'Exit Full screen'),
      }));
      map.addControl(new L.control.zoom({
        zoomInTitle: this.translate('zoomInTitle', 'Zoom in'),
        zoomOutTitle: this.translate('zoomOutTitle', 'Zoom out'),
        position: 'bottomright'
      }));
      const mapAttributionControlTitle = this.translate('mapAttributionControlTitle', 'Leaflet - A JavaScript library for interactive maps');
      map.attributionControl.setPrefix(
        `<a target="_blank" href="https://leafletjs.com" title="${mapAttributionControlTitle}">Leaflet</a>`
      );
      // Set default aria-expanded false to all markers.
      map.on('layeradd', e => {
        const layer = e.layer;
        if (layer instanceof L.Marker) {
          const el = layer?._icon;
          if (el) {
            el.setAttribute('aria-expanded', 'false');
          }
        }
      });
    },
    onPopupOpen($event) {
      const popup = $event?.target?._popup;
      if (popup && popup._closeButton) {
        popup._closeButton.ariaLabel = this.translate('popupCloseTitle', 'Close popup');
      }
      const marker = popup?._source?._icon;
      if (marker) {
        marker.setAttribute('aria-expanded', 'true');
      }
    },
    onPopupClose($event) {
      const popup = $event?.target?._popup;
      const marker = popup?._source?._icon;
      if (marker) {
        marker.setAttribute('aria-expanded', 'false');
      }
    },
    initialPos() {
      throw new Error('initalPos method is not implemented.');
    },
    boundsUpdate(bounds) {
      this.bounds = bounds;
    },
    openPopup: function(event) {
      this.$nextTick(() => {
        event.target.openPopup();
      });
    },
    getServiceColor(service) {
      if (service && service.colors) {
        return service.colors.color;
      }
      return "#000";
    },
    getServiceBgColor(service) {
      if (service && service.colors) {
        return service.colors.bgcolor;
      }
      return "#FFF";
    },
    // Get string vehicule type label from integer type
    getVehiculeLabelType(typeId) {
      let types = {
        '0': "tramway",
        '1': "metro",
        '2': "train",
        '3': "bus",
        '4': "ferry",
        '5': "tramway",
        '6': "telepherique",
        '7': "funiculaire",
        '11': "trolleybus",
        '12': "monorail"
      };
      let vehiculeType = types[typeId];
      if (!vehiculeType) {
        vehiculeType = "bus";
      }
      return vehiculeType;
    }
  }
}
